import { graphql, useStaticQuery } from 'gatsby';

import { LogoSlug, LogoFile } from '../types/external-logos';

interface ExternalLogoFiles {
  rasters: {
    edges: LogoFile[];
  };
  vectors: {
    edges: LogoFile[];
  };
}

const useExternalLogos = (logos: LogoSlug[]) => {
  const { rasters, vectors }: ExternalLogoFiles = useStaticQuery(
    graphql`
      {
        rasters: allFile(filter: { sourceInstanceName: { eq: "externalLogos" }, ext: { ne: ".svg" } }) {
          edges {
            node {
              name
              publicURL
              childImageSharp {
                gatsbyImageData(width: 200)
              }
              fields {
                slug
                alt
              }
            }
          }
        }
        vectors: allFile(filter: { sourceInstanceName: { eq: "externalLogos" }, ext: { eq: ".svg" } }) {
          edges {
            node {
              name
              publicURL
              fields {
                slug
                alt
              }
            }
          }
        }
      }
    `,
  );

  const edges = [...rasters.edges, ...vectors.edges];
  const selectedLogos = logos.map(slug => edges.find(file => file.node.fields.slug === slug));
  return selectedLogos;
};

export default useExternalLogos;
